import React from "react";
import Top_bar from "../../Components/topBar/topBar";
import Api from "../../services/api";
import "../Prelude/prelude.css";
import Sidebar from "../../Components/sidebar/sideBar";
import "../../Components/reports/reports.css";
import InputReport from "../../Components/inputReport/inputReport";
import "../../Components/inputReport/inputReport.css";
import moment from "moment";
import MessageTable from "../../Components/messageTable/MessageTable";
import DatePicker from "../../Components/datePicker/datePicker";
import ExcelButton from "../../Components/exportExcelButton/ExportExcelButton";
import Spinner from "react-bootstrap/Spinner";
import styles from "../General/details.module.css";
import "./generalReports.css";
import TableList from "../../Components/tableList/TableList";
import BottomBar from "../../Components/bottomBar/bottomBar";
import Button from '../../Components/commonButton/commonButton';
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FilterBox from "../../Components/filterBox/filterBox";

class reportRefuses extends React.Component {
  state = {
    text: "",
    data: [],
    initialData: [],
    code: null,
    start_date: new Date().toLocaleDateString('pt-BR'),
    end_date: new Date().toLocaleDateString('pt-BR'),
    machine: "",
    item: "",
    loading: false,
  };

  async componentDidMount() {

  }

  filter = (data, name) => {
    /*  if (this.state[`${name}`].name === name) {
       let FilterCamp = this.state[`${name}`];
       FilterCamp.value = data; */
    this.setState({ [`${name}`]: data });
    /* } */
    /*  if (data.length === 0) {
       this.setState({ data: this.state.initialData });
     } else {
       let result = this.state.data.filter(
         (value) =>
           value[`${name}`].toLowerCase() ===
           this.state[`${name}`].value.toLowerCase()
       );
       if (result.length > 0) {
         this.setState({ data: result });
       }
     } */
  };

  saveText = (data) => {
    const { value, name } = data;
    console.log(name+' - '+value)
    this.setState({ [`${name}`]: value });
    /*  this.filter(value, name); */
  };

  filterData = (data, name) => {
    /*  if (this.state[`${name}`].name === name) {
       let dateFilterCamp = this.state[`${name}`];
       dateFilterCamp.date = data; */
    this.setState({ [`${name}`]: data });
    /* } */

    /* const { initialData, start_date, end_date } = this.state;
    if (data.length < 10) {
      this.setState({ data: initialData });
    } else {
      let result = initialData.filter((value) => {
        return (
          value["Data"] >= start_date.date && value["Data"] <= end_date.date
        );
      });
      if (result.length > 0) {
        this.setState({ data: result });
      } else {
        this.setState({ data: initialData });
      }
    } */
  };

  sendData = async () => {
    const params = {
      machine: this.state.machine.trim(),
      item: this.state.item.trim(),
      dt_ini: this.state.start_date,
      dt_end: this.state.end_date
    }
    console.log(params)
    let count = 0
    for (let p in params) {
      if (params[p])
        count++
    }
    if (count > 0) {
      this.setState({ loading: true })
      await Api.get("/reports/refuses",{params:params})
        .then((resp) => {
          let arr = [];
          if (resp.data.length === 0) {
            this.setState({ render: false });
          } else {
            console.log(resp.data);
            resp.data.forEach((element) => {
              arr.push({
                Máquina: element.Máquina,
                Ordem: element.Ordem,
                Item: element.Item,
                Operador: element.operador,
                Quantidade: `${element["N° de peças"]}${element.Unidade}`,
                Data: moment(element.Data).format("DD/MM/YYYY"),
                Hora: element.Hora,
                Motivo: element["Motivo de Refugo"],
                Turno: element.Turno,
                Detalhes: element.Detalhes,
              });
            });
            this.setState({ data: arr, render: true, initialData: arr });
            if (this.state.loading) this.setState({ loading: false });
          }
        })
        .catch((err) => {
          alert("Erro de conexão com o servidor");
        });
      await Api.get("/work-shifts/")
        .then((resp) => {
          let arr_codes = [];
          let arr_ids = [];
          resp.data.forEach((element) => {
            arr_codes.push({ value: element.code });
            arr_ids.push({ id: element.id, code: element.code });
          });
          this.setState({ arrayWorkShifts: arr_codes, arr_idcodes: arr_ids });
          if (this.state.loading) this.setState({ loading: false });
        })
        .catch((error) => {
          if (error.response) {
            return alert(
              error.response.data +
              "\n" +
              error.response.status +
              "\n" +
              error.response.headers
            );
          }
        });
    } else {
      alert("Preencha um campo de filtro");
    }
  }

  excelbutton = (event) =>{
    if(this.state.data.length === 0){
        alert("Preencha um campo de filtro")
        event.preventDefault()
    }
       
   }

  render() {
    let keys = null;
    const Row = ({ record }) => {
      const keys = Object.keys(record);
      return (
        <tr key={record.id}>
          {keys.map((key) => (
            <td key={key}>{record[key]}</td>
          ))}
        </tr>
      );
    };

    if (this.state.render) {
      keys = Object.keys(this.state.data[0]);
    }

    return (
      <>
          <div className="filters boxReport">
            <FilterBox title="Filtros">
            <div className="elementFilter" type="input">
                  <InputReport
                    name="machine"
                    parentCallback={this.saveText}
                    title="Máquina"
                    focus={true}
                  />
                </div>
                <div className="elementFilter" type="input">
                  <InputReport
                    name="item"
                    parentCallback={this.saveText}
                    title="Item"
                    />
                </div>
                <div className="elementFilter" type="input">
                  <DatePicker
                    name="Data"
                    title="Data Inicial"
                    parentCallback={(e) => this.filterData(e, "start_date")}
                  ></DatePicker>
                </div>
                <div className="elementFilter" type="input">
                  <DatePicker
                    name="Data"
                    title="Data Final"
                    parentCallback={(e) => this.filterData(e, "end_date")}
                  ></DatePicker>
                </div>

                <div className="buttonFilter" type="button">
                    <ExcelButton onClick={this.excelbutton}
                      data={this.state.data}
                      filename={`refugos_${moment()
                        .utc()
                        .utcOffset("-03:00")
                        .format("DDMMYY_HHmmss")}.csv`}
                    />
                  </div>
                  <div className="buttonFilter" type="button">
                    <Button size title="Gerar" icon="faGear" parentCallback={this.sendData} />
                  </div>
            </FilterBox>
            {this.state.loading ? (
              <div >
                <div style={{ marginTop: '20vh' }} className={styles.loader}>
                  <Spinner variant="success" animation="border" />
                  <strong>Carregando...</strong>
                </div>
              </div>
            ) : (
              <>
                {this.state.render ? (
                  <div className="TableReport">
                    <TableList data={this.state.data}></TableList>
                  </div>
                ) : (
                  <div className="TableReport">
                    <MessageTable message={"Sem dados para processar."} />
                  </div>
                )}
              </>
            )}
          </div>
      </>
    );
  }
}

export default reportRefuses;